import { useCallback, useEffect, useMemo, useState } from 'react'

export const useRowSelection = (props: { ids: number[] }) => {
  const [selection, setSelection] = useState<number[]>([])

  const isEveryRowSelected = useMemo(() => props.ids.every((id) => selection.includes(id)), [selection, props.ids])

  const onAllSelectionToggle = useCallback(() => {
    if (isEveryRowSelected) {
      setSelection([])
    } else {
      setSelection(props.ids)
    }
  }, [isEveryRowSelected, props])

  const onSelectionToggle = useCallback(
    (id: number) => {
      if (selection.includes(id)) {
        setSelection(selection.filter((id_) => id_ !== id))
      } else {
        setSelection([...new Set([...selection, id])])
      }
    },
    [selection]
  )

  // Reset the selected IDs when the data changes.
  useEffect(() => {
    setSelection([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.ids])

  return {
    selection,
    isEveryRowSelected,
    onAllSelectionToggle,
    onSelectionToggle,
  }
}
